<template>
  <div>
    <div class="container mb-14 lg:mb-20 mt-10">
      <CategoryBar @change="onCategoryChange" />
      <div v-if="loading" class="grid md:grid-cols-3 gap-6">
        <shimmer-article v-for="i in 6" :key="i" />
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        <ProjectCard v-for="item in businesses" :key="item" :item="item" />
      </div>

      <p class="text-lg md:text-xl" v-if="!businesses?.length && !loading">
        لا يوجد نتائج ...
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const category = ref<Record<string, string>>();

const onCategoryChange = ({value}: {value: Record<string, string>}) => {
  if (!value) return;
  category.value = value;
};

const filter = computed(() => {
  return {
    category: category.value?.id || "",
  };
});

const {businesses, loading} = useBusinesses(filter);
</script>
